var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCollections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.5,2.8C8.7,2.6,9,2.5,9.3,2.5h11.2c0.3,0,0.6,0.1,0.8,0.3c0.2,0.2,0.3,0.5,0.3,0.8v11.2 c0,0.3-0.1,0.6-0.3,0.8c-0.2,0.2-0.5,0.3-0.8,0.3H17V9.1c0-0.6-0.2-1.1-0.6-1.5C16,7.2,15.4,7,14.9,7H8.2V3.7 C8.2,3.4,8.3,3.1,8.5,2.8z M7.2,7V3.7c0-0.6,0.2-1.1,0.6-1.5c0.4-0.4,1-0.6,1.5-0.6h11.2c0.6,0,1.1,0.2,1.5,0.6 c0.4,0.4,0.6,1,0.6,1.5v11.2c0,0.6-0.2,1.1-0.6,1.5c-0.4,0.4-1,0.6-1.5,0.6H17v3.3c0,0.6-0.2,1.1-0.6,1.5c-0.4,0.4-1,0.6-1.5,0.6 H3.7c-0.6,0-1.1-0.2-1.5-0.6c-0.4-0.4-0.6-1-0.6-1.5V9.1c0-0.6,0.2-1.1,0.6-1.5C2.5,7.2,3.1,7,3.7,7H7.2z M16,16.5V9.1 c0-0.3-0.1-0.6-0.3-0.8C15.5,8.1,15.2,8,14.9,8H7.7h0h-4C3.4,8,3.1,8.1,2.8,8.3C2.6,8.5,2.5,8.8,2.5,9.1v11.2c0,0.3,0.1,0.6,0.3,0.8 c0.2,0.2,0.5,0.3,0.8,0.3h11.2c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8L16,16.5C16,16.6,16,16.5,16,16.5L16,16.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollections);
export default __webpack_public_path__ + "static/media/icon-collections.f64a9643dbe3797a8ca8b43b8c4f654f.svg";
export { ForwardRef as ReactComponent };